import {Term} from '../../terms/components/TermsComponent';

export const definitions: Term[] = [
  {
    id: '1.1',
    term:
      'This section provides information about the licenses governing the software components used in our application. These licenses ensure transparency and compliance with legal requirements while respecting the contributions of the open-source community. Below, you will find the specific license terms and conditions for each component, including FFmpeg and other GPL-licensed code. These terms outline the rights and responsibilities of users, including access to source code and attribution requirements, helping to maintain the integrity and openness of the software we rely on.',
  },
];
